import { gql } from '@apollo/client';

export const GET_REGIONS_QUERY = gql`
  query getRegionsQuery(
    $master_list: Boolean
    $group_id: String
    $company_id: String
    $id: String
  ) {
    regions(master_list: $master_list, group_id: $group_id, company_id: $company_id, id: $id) {
      id
      deleted
      name
      country {
        id
        deleted
        name
        continent
        code
        reference {
          id
          path
          parentPath
        }
      }
      archived
      reference {
        id
        path
        parentPath
      }
    }
  }
`;

export const ALLOW_DELETE_REGIONS_QUERY = gql`
  query allowDeleteRegionsQuery($group_id: String, $company_id: String, $region_id: String) {
    allowDeleteRegion(group_id: $group_id, company_id: $company_id, region_id: $region_id)
  }
`;
